import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, ReplaySubject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { UserPermissionsService } from '../api-authorization/user-permissions.service';

@Injectable({
  providedIn: 'root'
})
export class ThirdPartyExpensesService {

  baseUrl = 'ThirdPartyExpenses';

  constructor(private httpClient: HttpClient, private userPermissionsService: UserPermissionsService) {
  }

  private expenses$: ReplaySubject<ThirdPartyExpenses[]> = new ReplaySubject(1);
  public get thirdPartyExpenses(): Observable<ThirdPartyExpenses[]> { return this.expenses$.asObservable() }

  loadThirdPartyExpenses(docId: number): Observable<ThirdPartyExpenses[]> {
    const url = `${this.baseUrl}/${docId}`;

    if (!this.userPermissionsService.CanViewExpensesTab) {
      return of()
    }

    return this.httpClient.get<IThirdPartyExpenses[]>(url).pipe(map(response => {
      return response.map(value => Object.assign(new ThirdPartyExpenses(), value))
    })).pipe(tap(data => { this.expenses$.next(data); }));
  }

  getAttachmentLink(apDocId: string): Observable<string> {
    if (!this.userPermissionsService.CanViewAttachmentsTab) {
      return of();
    }
    const url = `${this.baseUrl}/attachmentLink/${apDocId}`;
    return this.httpClient.get<string>(url);
  }

}

export interface IThirdPartyExpenses {
  Vendor: string;
  EstAmount: number;
  ActAmount: number;
  APDoc: string;
  VendorCode: string;
}

export class ThirdPartyExpenses implements IThirdPartyExpenses {
  Vendor: string = '';
  EstAmount: number = 0;
  ActAmount: number = 0;
  APDoc: string = '';
  VendorCode: string = '';

  get Diff() { return this.ActAmount - this.EstAmount }
  get DiffPercent() {
    if (this.Diff == 0 || this.EstAmount == 0) { return 0 }
    return this.Diff / this.EstAmount
  }
}
